// extracted by mini-css-extract-plugin
module.exports =  {"body":"body--Uo9C1","body-grid":"body-grid--b5Ima","bodyGrid":"body-grid--b5Ima"};